/**
 * The home URL with the `?msid=` arrival's parameters removed, or `null` when it carries none.
 *
 * An arrival that resolves to a pack never renders the home (lib/msid-arrival.js redirects it to
 * `/pack-accept` on the server). One that doesn't (no pack, spec off, lookup down) lands here with the
 * parameters still on, and they have done their job: left on, a reload or a copied link would ask
 * again for a site the visitor may not even be on. Pure, so the home's effect is a one-liner.
 */
export const MSID_ARRIVAL_PARAMS = ['msid', 'entry'];

export function withoutMsidArrival(search: string): string | null {
  const params = new URLSearchParams(search);
  if (!MSID_ARRIVAL_PARAMS.some((param) => params.has(param))) return null;
  for (const param of MSID_ARRIVAL_PARAMS) params.delete(param);
  const rest = params.toString();
  return rest ? `?${rest}` : '';
}
